var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPreview = function SvgPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.813 1.375a3.442 3.442 0 0 0-3.438 3.438v12.375a3.441 3.441 0 0 0 3.438 3.437h12.375a3.441 3.441 0 0 0 3.437-3.438V4.813a3.441 3.441 0 0 0-3.438-3.437H4.813zM17.188 22H4.813A4.819 4.819 0 0 1 0 17.187V4.813A4.819 4.819 0 0 1 4.813 0h12.375A4.82 4.82 0 0 1 22 4.813v12.375A4.819 4.819 0 0 1 17.187 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55 11c.827 1.975 3.122 3.438 5.45 3.438 2.328 0 4.623-1.463 5.45-3.438-.827-1.975-3.122-3.438-5.45-3.438-2.328 0-4.623 1.463-5.45 3.438M11 15.813c-3.02 0-5.895-1.928-6.836-4.583a.698.698 0 0 1 0-.46C5.104 8.115 7.98 6.188 11 6.188c3.02 0 5.895 1.927 6.836 4.582a.698.698 0 0 1 0 .46c-.94 2.655-3.815 4.582-6.836 4.582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7.563c-1.118 0-2.063 1.574-2.063 3.437 0 1.863.945 3.438 2.063 3.438 1.118 0 2.063-1.575 2.063-3.438 0-1.863-.945-3.438-2.063-3.438m0 8.25c-1.928 0-3.438-2.114-3.438-4.812 0-2.698 1.51-4.813 3.438-4.813 1.928 0 3.438 2.115 3.438 4.813 0 2.698-1.51 4.813-3.438 4.813"
  }))));
};

export default SvgPreview;